import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import styles from '../css/LiveGameView.module.css'
import { GameFeedContext } from '../useCreateGameData'
import { StatisProGameContext } from '../useStatisProGameData'
import MatchupBox from './MatchupBox'
import { formatDate } from '../ScheduleView'
import { useParams } from 'react-router'

export default function GameControlPanel({ incrementEvent }: { incrementEvent: (inc: number) => void }) {
  const { gameId } = useParams()
  const isStatisProGame = parseInt(gameId ?? '') === 0
  
  // Use appropriate context based on game type
  const mlbContext = useContext(GameFeedContext)
  const statisProContext = useContext(StatisProGameContext)
  // const [{ rawData, isMobileLayout, currentEventHasCompleted, autoPlayEnabled }, mlbDispatch] = mlbContext
  const [statisProState, statisProDispatch] = statisProContext
  const autoPlayEnabled : boolean = false
  
  // Use the appropriate state and dispatch
  const state = isStatisProGame ? statisProState : statisProState
  const dispatch = isStatisProGame ? statisProDispatch : statisProDispatch
  
  const formattedDate = useMemo(() => formatDate(new Date(state.rawData?.gameData.datetime.dateTime ?? '')), [state.rawData?.gameData.datetime.dateTime])
  
  function toggleAutoplay() {
    // dispatch({ type: 'SET_AUTOPLAY_ENABLED', autoPlayEnabled: !state.autoPlayEnabled } as any)

    // if (state.currentEventHasCompleted && !state.autoPlayEnabled) {
    //   if (isStatisProGame) {
    //     (dispatch as any)({ type: 'SIMULATE_NEXT_PLAY' })
    //   } else {
    //     (dispatch as any)({ type: 'INCREMENT_EVENT', increment: 1 })
    //   }
    // }
  }
  
  // Add debouncing to prevent duplicate dispatches
  const [isDispatching, setIsDispatching] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  function handleNextEvent() {
    if (isDispatching) {
      console.log('[GameControlPanel] Prevented duplicate dispatch - button is locked');
      return;
    }
    
    setIsDispatching(true);
    console.log('[GameControlPanel] Next event button clicked - dispatching SIMULATE_NEXT_PLAY');
    (dispatch as any)({ type: 'SIMULATE_NEXT_PLAY', source: 'button_click' });
    
    // Clear any existing timeout
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
    
    // Reset after a short delay
    timeoutRef.current = window.setTimeout(() => {
      setIsDispatching(false);
      timeoutRef.current = null;
    }, 800); // Prevent additional dispatches for 800ms
  }

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.gameControlsContainer}>
      {<MatchupBox />}
      <div className={styles.flexRow} style={{ height: 45, marginBottom: 4 }}>
        <div
          onClick={() => incrementEvent(-1)}
          className={styles.controlButtons}>{"<<"}
        </div>
        <div
          className={styles.controlButtons}
          style={{ color: autoPlayEnabled ? 'yellow' : 'white', flexGrow: 1 }}
          onClick={toggleAutoplay}
        >
          {autoPlayEnabled ? 'AUTOPLAY ON' : 'AUTOPLAY OFF'}
        </div>
        <div
          onClick={handleNextEvent}
          className={styles.controlButtons}
          style={{
            opacity: isDispatching ? 0.5 : 1,
            cursor: isDispatching ? 'not-allowed' : 'pointer'
          }}
        >{">>"}</div>
      </div>
      <div className={styles.controlsInfoBox}>
        {isStatisProGame ? (
          <>
            Texas Longhorns VS Oklahoma Sooners
            <div style={{ color: 'gray', textAlign: 'center', marginTop: 5 }}>
              <div>Statis Pro Baseball Simulation</div>
              Manual Control Mode
            </div>
          </>
        ) : (
          <>
            {state.rawData?.gameData.teams.home.clubName} VS {state.rawData?.gameData.teams.away.clubName}
            <div style={{ color: 'gray', textAlign: 'center', marginTop: 5 }}>
              <div>{state.rawData?.gameData.venue.name}</div>
              {formattedDate}
            </div>
          </>
        )}
      </div>
    </div>
  )
}